import { gray40opacity20, gray95opacity10 } from '../../../colors/gray';
import { neutral60opacity05 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
import { listStylesDark } from './MuiListItem';
export var MuiList = {
    styleOverrides: {
        root: {
            '& [class*=MuiListItem-personName]': {
                backgroundColor: gray95opacity10,
                borderBottom: "".concat(rem(1), " solid ").concat(gray40opacity20),
            },
            '&:focus-visible': {
                outline: listStylesDark.focusVisible.outline,
            },
        },
    },
    customOverrides: {
        rowSeparator: {
            '& [class*=MuiListItem-root]': {
                borderBottom: "".concat(rem(1), " solid ").concat(gray40opacity20),
            },
        },
        zebra: {
            '& [class*=MuiListItem-root]:nth-of-type(even)': {
                backgroundColor: neutral60opacity05,
            },
        },
        outlineItemsOnFocus: {
            '& > [class*=MuiListItem-root]:focus, & > [class*=MuiListItemButton]:focus': {
                outline: listStylesDark.focusVisible.outline,
            },
        },
    },
};
